import { jsx as s, jsxs as q } from "react/jsx-runtime";
import { forwardRef as $, isValidElement as I, Children as L } from "react";
function B(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var d = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var m;
function C() {
  return m || (m = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function a() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var p = arguments[e];
          p && (r = n(r, u.call(this, p)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var p in r)
          i.call(r, p) && r[p] && (e = n(e, this && this[p] || p));
        return e;
      }
      function n(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
    })();
  }(d)), d.exports;
}
var R = C();
const w = /* @__PURE__ */ B(R), N = {
  "purpur-listbox": "_purpur-listbox_6c8yl_1",
  "purpur-listbox-item": "_purpur-listbox-item_6c8yl_15",
  "purpur-listbox-item--hovered": "_purpur-listbox-item--hovered_6c8yl_29",
  "purpur-listbox-item--highlighted": "_purpur-listbox-item--highlighted_6c8yl_37",
  "purpur-listbox-item--noninteractive": "_purpur-listbox-item--noninteractive_6c8yl_41",
  "purpur-listbox-item--disabled": "_purpur-listbox-item--disabled_6c8yl_44",
  "purpur-listbox-item__icon": "_purpur-listbox-item__icon_6c8yl_51"
};
function k(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var g = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var f;
function M() {
  return f || (f = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function a() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var p = arguments[e];
          p && (r = n(r, u.call(this, p)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var p in r)
          i.call(r, p) && r[p] && (e = n(e, this && this[p] || p));
        return e;
      }
      function n(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
    })();
  }(g)), g.exports;
}
var H = M();
const E = /* @__PURE__ */ k(H), z = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, G = E.bind(z), v = "purpur-icon", T = "md", V = (t) => t.filter((i) => Object.keys(i).length >= 1).map((i) => `${i.name}="${i.value}"`).join(" "), D = ({ content: t = "", title: i } = {}) => {
  const a = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    i ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], u = i ? `<title>${i}</title>` : "";
  return `<svg ${V(a)}>${u}${t}</svg>`;
}, F = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), S = ({
  ["data-testid"]: t,
  svg: i,
  allyTitle: a,
  className: u,
  size: n = T,
  ...r
}) => {
  const e = D({
    content: F(i.svg),
    title: a
  }), p = G(u, v, `${v}--${n}`);
  return /* @__PURE__ */ s(
    "span",
    {
      className: p,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: e },
      ...r
    }
  );
};
S.displayName = "Icon";
const Z = {
  name: "checkmark",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.06 3.795a.9.9 0 0 1 .145 1.264l-11.5 14.5a.9.9 0 0 1-1.341.077l-6-6a.9.9 0 0 1 1.272-1.272l5.286 5.286L19.795 3.94a.9.9 0 0 1 1.264-.145Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark"],
  category: "utility"
}, j = (t) => /* @__PURE__ */ s(S, { ...t, svg: Z });
j.displayName = "IconCheckmark";
function J(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var b = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var y;
function K() {
  return y || (y = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function a() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var p = arguments[e];
          p && (r = n(r, u(p)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var p in r)
          i.call(r, p) && r[p] && (e = n(e, p));
        return e;
      }
      function n(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
    })();
  }(b)), b.exports;
}
var Q = K();
const U = /* @__PURE__ */ J(Q), l = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, W = {
  PARAGRAPH100: "paragraph-100"
}, c = "purpur-paragraph", A = ({
  ["data-testid"]: t,
  children: i,
  className: a,
  disabled: u,
  enableHyphenation: n = !1,
  negative: r = !1,
  variant: e = W.PARAGRAPH100,
  ...p
}) => {
  const h = U([
    a,
    l[c],
    l[`${c}--${e}`],
    {
      [l[`${c}--hyphens`]]: n,
      [l[`${c}--disabled`]]: u,
      [l[`${c}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ s("p", { ...p, className: h, "data-testid": t, children: i });
};
A.displayName = "Paragraph";
const x = w.bind(N), o = "purpur-listbox", _ = $(
  (t, i) => {
    const { disabled: a, highlighted: u, hovered: n, selected: r, children: e, noninteractive: p, ...h } = t, P = x(`${o}-item`, h.className, {
      [`${o}-item--highlighted`]: u,
      [`${o}-item--selected`]: r,
      [`${o}-item--hovered`]: n,
      [`${o}-item--disabled`]: a,
      [`${o}-item--noninteractive`]: p
    });
    return /* @__PURE__ */ q(
      "li",
      {
        ...h,
        ref: i,
        className: P,
        "aria-selected": !!r,
        role: "option",
        "aria-disabled": !!a,
        children: [
          typeof e == "string" ? /* @__PURE__ */ s(A, { children: e }) : e,
          r && /* @__PURE__ */ s(j, { size: "xs", className: x(`${o}-item__icon`) })
        ]
      }
    );
  }
), X = (t) => I(t) && (t == null ? void 0 : t.type) === _;
_.displayName = "ListBoxItem";
const Y = w.bind(N), rr = "purpur-listbox", O = $(
  ({ children: t, ...i }, a) => /* @__PURE__ */ s(
    "ul",
    {
      ...i,
      ref: a,
      className: Y(rr, i.className),
      role: "listbox",
      children: L.toArray(t).filter(X)
    }
  )
);
O.Item = _;
O.displayName = "ListBox";
export {
  O as Listbox
};
//# sourceMappingURL=listbox.es.js.map
